import React, { useState, useEffect, useRef, useMemo, useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import CustomDatePicker from '../../../components/form-date/components/CustomDatePicker/CustomDatePicker';
import FormInput from '../../form-input/FormInput/FormInput';
import UserContext, { UserProfileContext } from '../../../../../common/utils/getContext';
import moment from 'moment';
import { useWidgetTranslates } from '../../../../../common/utils/utils';
import css from './FormDateRange.module.scss';
import classnames from 'classnames';
import { getDefaultVariation } from '../../helpers';
import { generateCompStylers } from '../../../../../common/utils/styles';
import { getDatePlaceholder, getFormattedDate } from '../initData';

const DatePickerRange = (props) => {
    const {
        variation,
        attribute,
        handlers = {},
        setFormData,
        value,
        compStyle = {},
        placeholder,
        mobileRangeDateCustom = false,
        config,
        format_data = 'yyyy-MM-DD',
        title,
        options
    } = props;
    const execludeYear = !format_data || (!format_data?.includes('y') && !format_data?.includes('Y'));
    const { stylers, classes } = generateCompStylers(compStyle);
    const contextData = useContext(UserProfileContext) || {};
    const variationStyle = variation || getDefaultVariation(contextData, title);

    const pickerElement = useRef(null);
    const [val, setVal] = useState(value);
    const [show, setShow] = useState(false);
    const [focused, setFocused] = useState(false);
    const { settings, lang } = useContext(UserContext);
    const transl = useWidgetTranslates('form');
    const dateFormat = useCallback(
        (dating) => {
            return getFormattedDate(dating, execludeYear, settings, lang);
        },
        [lang, execludeYear, settings]
    );
    const placeholderText = useMemo(() => {
        if (placeholder) return placeholder;
        const double = (text) => text + ' - ' + text;
        return double(getDatePlaceholder(settings, execludeYear, transl));
    }, [placeholder, execludeYear, settings, transl]);
    const handleClose = useCallback(
        (dateRangeObj) => {
            setShow(false);
            handlers?.onBlur && handlers?.onBlur(attribute, val);
            if (handlers?.onChange && dateRangeObj) {
                handlers?.onChange(dateRangeObj);
            }
        },
        [attribute, handlers, val]
    );
    const handleShow = () => {
        setShow(true);
        handlers?.onFocus && handlers?.onFocus(attribute);
    };
    const getInputValue = useMemo(() => {
        if (!val) return null;
        const start =
            val.start && moment(val.start, format_data).isValid() ? dateFormat(moment(val.start, format_data)) : val.start;
        const end = val.end && moment(val.end, format_data).isValid() ? dateFormat(moment(val.end, format_data)) : val.end;

        return `${start || ''}${start && end ? ' - ' : ''}${end || ''}`;
    }, [dateFormat, val, format_data]);
    useEffect(() => {
        setFormData(attribute, val);
    }, [val, attribute, setFormData]);
    useEffect(() => {
        setVal(value);
    }, [value]);
    return (
        <>
            <div
                style={stylers.wrapper}
                className={classnames(css.formGroup, classes.wrapper, css[variationStyle])}
                onClick={handleShow}
                onMouseOver={() => {
                    setFocused(true);
                }}
                onMouseLeave={() => {
                    setFocused(false);
                }}
                ref={pickerElement}
            >
                <FormInput
                    {...props}
                    noWrapper={true}
                    readonly={true}
                    placeholder={placeholderText}
                    value={getInputValue}
                    compStyle={{
                        ...compStyle,
                        calendar: {
                            // button: { width: '24px', height: '24px' },
                            icon: {
                                fill: focused || show ? 'var(--goldColor)' : 'var(--gold700Color)'
                            }
                        }
                    }}
                    hint={false}
                    buttons={{
                        ...props.buttons,
                        calendar: {
                            icon: 'calendar-icon-filled-new',
                            handler: handleShow,
                            hint: props.hint
                        }
                    }}
                />
            </div>
            {!!show && (
                <CustomDatePicker
                    format_data={format_data}
                    handleClose={handleClose}
                    setVal={setVal}
                    pickerElement={pickerElement}
                    mobileRangeDateCustom={mobileRangeDateCustom}
                    config={config}
                    options={options}
                />
            )}
        </>
    );
};
DatePickerRange.propTypes = {
    attribute: PropTypes.string,
    handlers: PropTypes.object,
    setFormData: PropTypes.func,
    value: PropTypes.string,
    compStyle: PropTypes.object,
    placeholder: PropTypes.node
};
export default DatePickerRange;
